import { OreDivider, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import { Trans, useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { createApiAutoEnrollmentRepository } from '@/AutoEnrollment/infrastructure'
import { ContractNewProductsProvider } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { ContractNewProductsStepper } from '@/Contract/ui/organisms'
import { PageWrapper } from '@/Shared/ui/layout'

export const ContractNewProductsPage = (): JSX.Element => {
  const { t } = useTranslation()

  const location = useLocation()

  return (
    <ContractNewProductsProvider
      autoEnrollmentRepository={createApiAutoEnrollmentRepository()}
      origin={location.state?.origin}
    >
      <PageWrapper paddingTop={40}>
        <OreHeading as="h1" size="title-md">
          {t(productContractingTranslation.contractProductPage.pageTitle)}
        </OreHeading>
        <OreDivider space="medium" />
        <OreStack space="large" placeContent="stretch">
          <ContractNewProductsStepper />
        </OreStack>
      </PageWrapper>
    </ContractNewProductsProvider>
  )
}
